import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7b148c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lux-widget"
}
const _hoisted_2 = {
  key: 0,
  class: "lux-widget__panel card"
}
const _hoisted_3 = { class: "lux-widget__header d-flex align-items-center justify-content-between px-5 py-4" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list fs-4" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-900 lh-1" }, "Lux", -1))
const _hoisted_8 = { class: "text-gray-500 fs-8" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square fs-5" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrows-fullscreen fs-6" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg fs-5" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "lux-widget__body p-3"
}
const _hoisted_17 = {
  key: 0,
  class: "text-gray-500 fs-7 text-center py-10"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "overflow-hidden me-2" }
const _hoisted_20 = { class: "text-gray-900 fw-bold fs-7 text-truncate" }
const _hoisted_21 = { class: "text-gray-500 fs-8" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-7" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  ref: "scroller",
  class: "lux-widget__body px-4 py-3"
}
const _hoisted_26 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm text-primary" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 fs-7 mb-0 px-4" }, " Travou numa máquina? Quer um plano de estudo? Manda ver. ", -1))
const _hoisted_31 = {
  key: 2,
  class: "d-flex align-items-center text-gray-500 fs-8 ms-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" escrevendo... ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "lux-widget__footer px-4 py-3"
}
const _hoisted_36 = {
  key: 0,
  class: "alert alert-danger py-2 px-3 fs-8 mb-2"
}
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 0,
  class: "bi bi-x-lg fs-2 text-white"
}
const _hoisted_39 = {
  key: 1,
  src: "/media/lux/lux_64.png",
  alt: "Lux"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LuxAvatar = _resolveComponent("LuxAvatar")!
  const _component_LuxMessage = _resolveComponent("LuxMessage")!
  const _component_LuxComposer = _resolveComponent("LuxComposer")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "lux-panel" }, {
          default: _withCtx(() => [
            (_ctx.open)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (_ctx.view === 'chat' && _ctx.conversations.length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-icon btn-sm btn-active-light-primary me-2",
                            title: "Conversas",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.view = 'history'))
                          }, _hoisted_6))
                        : _createCommentVNode("", true),
                      _createVNode(_component_LuxAvatar, {
                        size: 36,
                        thinking: _ctx.isSending,
                        class: "me-3"
                      }, null, 8, ["thinking"]),
                      _createElementVNode("div", null, [
                        _hoisted_7,
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.isSending ? "pensando..." : "mentora de segurança ofensiva"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-sm btn-active-light-primary me-1",
                        title: "Nova conversa",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNewConversation && _ctx.onNewConversation(...args)))
                      }, _hoisted_11),
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-sm btn-active-light-primary me-1",
                        title: "Abrir em tela cheia",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openFullscreen && _ctx.openFullscreen(...args)))
                      }, _hoisted_13),
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-sm btn-active-light-primary",
                        title: "Fechar",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open = false))
                      }, _hoisted_15)
                    ])
                  ]),
                  (_ctx.view === 'history')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (!_ctx.conversations.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Nenhuma conversa ainda. "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conversation) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: conversation.uuid,
                            class: "lux-widget__history-item d-flex align-items-center justify-content-between p-3 rounded mb-1",
                            onClick: ($event: any) => (_ctx.onOpenConversation(conversation.uuid))
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(conversation.title || "Sem título"), 1),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDate(conversation.last_message_at)), 1)
                            ]),
                            _createElementVNode("button", {
                              class: "btn btn-icon btn-sm btn-active-light-danger",
                              title: "Apagar",
                              onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(conversation.uuid)), ["stop"])
                            }, _hoisted_24, 8, _hoisted_22)
                          ], 8, _hoisted_18))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                          : (!_ctx.messages.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(_component_LuxAvatar, {
                                  size: 72,
                                  class: "mx-auto mb-4"
                                }),
                                _hoisted_30
                              ]))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                          return (_openBlock(), _createBlock(_component_LuxMessage, {
                            key: message.id,
                            message: message
                          }, null, 8, ["message"]))
                        }), 128)),
                        (_ctx.isSending)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
                          : _createCommentVNode("", true)
                      ], 512)),
                  (_ctx.view === 'chat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_ctx.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.error), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_LuxComposer, {
                          ref: "composer",
                          sending: _ctx.isSending,
                          disabled: _ctx.reachedLimit,
                          remaining: _ctx.remaining,
                          suggestions: _ctx.config?.suggested_prompts ?? [],
                          "show-suggestions": !_ctx.messages.length,
                          onSend: _ctx.onSend
                        }, null, 8, ["sending", "disabled", "remaining", "suggestions", "show-suggestions", "onSend"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          class: _normalizeClass(["lux-widget__launcher", { 'lux-widget__launcher--open': _ctx.open }]),
          title: _ctx.open ? 'Fechar a Lux' : 'Falar com a Lux',
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, [
          (_ctx.open)
            ? (_openBlock(), _createElementBlock("i", _hoisted_38))
            : (_openBlock(), _createElementBlock("img", _hoisted_39))
        ], 10, _hoisted_37)
      ]))
    : _createCommentVNode("", true)
}